// extracted by mini-css-extract-plugin
export default {"background-container":"BackgroundVideo_background-container__DAS2X","background-video":"BackgroundVideo_background-video__V14p-"};